import { WrapperGS } from '../core/WrapperGS';
import { a, p } from './html';
/** Clear string for parse to number */
export function formalForNumber(value: string): string {
    if (!value) return value;
    let result = value;
    result = result.replace(/[,]/g, '.');
    result = result.replace(/[^-.,\d]/g, '');
    return result;
}

export function uppercaseFirstLetter(string: string) { return string.charAt(0).toUpperCase() + string.slice(1); }
export function lowercaseFirstLetter(string: string) { return string.charAt(0).toLowerCase() + string.slice(1); }

export function clearHtmlToText(html: string): string
{    
    return html.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
}

export function htmlDecode(text: string): string { return p({}, text).textContent ?? ''; };

export function replaceAll(str: string, target: string, replace: string): string
{
    const escapedTarget = target.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return str.replace(new RegExp(escapedTarget, 'g'), () => replace);
}


export function parseHost(url: string): string {
    const anchor = a({ href: url });
    return anchor.host;
}

export function parsePath(url: string): string {
    const anchor = a({ href: url });
    return anchor.pathname;
}

export function createUrlArgs(data: object): string {
    const urlArgs: string[] = [];
    const values = data as Record<string, any>;
    for (const key in values) urlArgs.push(`${key}=${encodeURIComponent(values[key])}`);
    return urlArgs.join('&');
};


export function copyToClipboard(text: string): boolean {
    const textarea = document.createElement("textarea");
    textarea.textContent = text;
    textarea.style.position = "fixed";
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    const successful = document.execCommand('copy');
    WrapperGS.Wrap(textarea).cut();
    return successful;
};
